<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Business model innovation",
    "pageDesc":"Enhancing your organizational performance through business model innovation that deeply examines your operating model and implement changes.",
    "mantra":"Innovating your |business model.",
    "mantraDesc":"We help you grow your business  by discovering new opportunities. With our expertise in the business field, we collaborate with your delivering operating models and addressing your ongoing operational concerns. ",
    "sec1":"Strategic value creation starts within.",
    "sec1Items":{
      "1":{
        "title":"Revolutionary value proposition",
        "desc":"We examine your current business model, business environment and past year results to see possible chances of enhancement across in product or service offering, revenue model or choice of the target segment."
      },
      "2":{
        "title":"Operating model enhancements",
        "desc":"Based on your industry and your scale of operations, we consult you on how to capitalize on your operation model to create a real competitive advantage and drive profitability."
      }
    },
    "sec2Items":{
      "1":{
        "title":"Addressing concerns",
        "desc":"We help you with your burning questions starting from which business model y9ou should be following to adopting and scaling your business operations."
      },
      "2":{
        "title":"Performance enhancement",
        "desc":"Increase your business numbers and breakthrough growth through a strategic and data driven approach for business model innovation."
      },
      "3":{
        "title":"Consolidated strategy ",
        "desc":"We breakdown the operational problems and setup an implementation model that tackles every aspect of the business in detail."
      }
    },
    "cta":"Enhance your business <br> model. "
  },
  "ar": {
    "pageTitle":"ابتكار نماذج الأعمال",
    "pageDesc":"حسّن من أداء مؤسستك من خلال ابتكار نموذج العمل الخاص بك الذي يعكس بعمق نموذج التشغيل وكيفية الحصول على الأرباح وكيفية إدارة القنوات.",
    "mantra":"إنشاء قيم فريدة عبر |ابتكار نماذج الأعمال.",
    "mantraDesc":"نساعدك على تنمية عملك من خلال اكتشاف فرص جديدة له. من خلال الخبرة التي نتمع بها في مجال الأعمال، نتعاون معك لتقديم نموذج تشغيل ومعالجة المخاوف التي تدور في ذهنك.",
    "sec1":"إنشاء القيمة الاستراتيجية يبدأ من الداخل.",
    "sec1Items":{
      "1":{
        "title":"قيمة مقدمة مبتكرة",
        "desc":"ندرس نموذج عملك الحالي وبيئة العمل وكذلك النتائج التي حققتها في العام الماضي من أجل معرفة الفرص التي من استغلالها من أجل التحسين سواء في عرض المنتج أو نموذج الإيرادات أو اختيار الجمهور المستهدف."
      },
      "2":{
        "title":"تحسينات نموذج التشغيل",
        "desc":"استنادًا إلى مجال عملك وحجم عملياتك التي تقوم بها، فإننا نتشاور سويًا حول كيفية الاستفادة من نموذج التشغيل الخاص بك لإنشاء ميزة تنافسية حقيقية وزيادة الربحية."
      }
    },
    "sec2Items":{
      "1":{
        "title":"معالجة المخاوف",
        "desc":"نساعدك في طرح الأسئلة الملحة والإجابة عليها بدءًا من نموذج العمل الذي يجب أن تتبعه من أجل بناء وتوسيع نطاق عمليات عملك."
      },
      "2":{
        "title":"تحسين الأداء",
        "desc":"نساعدك على زيادة عدد أعمالك وتحقيق النمو من خلال نهج استراتيجي يعتمد على البيانات في ابتكار نموذج العمل."
      },
      "3":{
        "title":"استراتيجية موحدة ",
        "desc":"نفصل ونحدد المشكلات التشغيلية ونقوم بإعداد نموذج تنفيذ فعال يعالج كل جانب من جوانب العمل بالتفصيل."
      }
    },
    "cta":"حسّن نموذج عملك."
  }
}
</i18n>
